import React from 'react';
import PropTypes from 'prop-types';
import { BaselineThemeProvider } from '@luigiclaudio/ga-baseline-ui/theme-provider';
import { ModalProvider } from '@luigiclaudio/ga-baseline-ui/modal';
import { Header, HeaderOffset } from '@luigiclaudio/ga-baseline-ui/header';
import { useHasMounted, Loader, useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import { useUser, Identity } from '@luigiclaudio/ga-auth-theme';
import SiteIntlProvider from './SiteIntlProvider';
import theme from '../styles/theme';
import navigation from '../data/navigation.json';
import navigationMenuModal from '../data/navigationMenuModal.json';

import JotsProvider from './context/JotsProvider';

const Layout = ({ children }) => {
    const [user, isLoadingUser] = useUser();
    // eslint-disable-next-line no-console
    // console.log('layout user', user);
    const hasMounted = useHasMounted();
    const { logoutUser } = Identity.useIdentityContext();
    const [isLoading, load] = useLoading();

    const menuModalSecondaryListSignOut = {
        label: 'Sign out',
        btnType: 'outlined',
        skin: 'primary',
        icon: 'log-out',
        loading: isLoading,
        onClick: () =>
            load(logoutUser())
                .then((res) => {
                    return res;
                })
                .catch((err) => {
                    throw err;
                }),
    };

    return (
        <SiteIntlProvider>
            <BaselineThemeProvider theme={theme}>
                <ModalProvider>
                    {hasMounted && (
                        <Header
                            title="Jotty"
                            navigationList={user ? navigation.client : navigation.public}
                            menuModalSecondaryList={
                                user ? [menuModalSecondaryListSignOut] : navigationMenuModal.public
                            }
                        />
                    )}
                    <HeaderOffset>
                        {isLoadingUser && <Loader isFullScreen />}
                        <JotsProvider>{children}</JotsProvider>
                    </HeaderOffset>
                </ModalProvider>
            </BaselineThemeProvider>
        </SiteIntlProvider>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
